import {createStyledAnimation} from '../create-styled-animation';
import {fadeFlowBuilder} from '../fade/fade';
import {slideFlowBuilder, SlideProps} from '../slide/slide';
import {PropertyFlowDescription} from '../style-animation';
import {Duration} from '../types';

export function slideFadeFlowBuilder(duration: Duration, flowProps: SlideProps): PropertyFlowDescription[] {
	const fadeFlow = fadeFlowBuilder(duration);
	const slideFlow = slideFlowBuilder(duration, flowProps);
	return slideFlow.concat(fadeFlow);
}

export const SlideFade = createStyledAnimation('SlideFade', slideFadeFlowBuilder, ['axis', 'from']);
